import { getImageFullPath } from "@/utils/appUtil";

export const APP_NAME = "NAILSUPPLY.US";
export const PrefixKey = "nailsupply_us";
export const DefaultLocale = "en";
export const LocaleKey = PrefixKey + "locale";
export const ThemeKey = PrefixKey + "theme";
export const DefaultApiCLient = "default";
export const AppAuthTokenKey = PrefixKey + "01";
export const AppAuthRefeshTokenKey = PrefixKey + "02";
export const AppAuthDataKey = PrefixKey + "03";
export const AppAuthTokenExpireKey = PrefixKey + "04";
export const AppAuthTokenCreatedKey = PrefixKey + "05";
export const ExpireCookieDays = 30;
export const autoRefeshTokenDays = 30;
export const SearchParamiter = "_q";
export const KeywordParamiter = "_keyword";
export const SearchMinCharactor = 1;
export const PageActionParamiter = "crud";
export const PageIdParamiter = "id";
export const BackendRootPath = undefined;
export const AdminRootPath = "admin";
export const CompanyIdAtt = "companyId";
export const UserIdAtt = "userId";
export const ProfileNameAtt = "userProfileId";
export const CacheDateCheckKey = PrefixKey + "_cache_date_check";
export const FcmTokenKey = PrefixKey + "_mb_fcm";
export const FcmSettingKey = PrefixKey + "_mb_fcm_setting";
export const NotifyKey = PrefixKey + "_mb_notify";
export const SearchHistoryKey = PrefixKey + "_searchs";
export const SucureDeviceIdAtt = "_device_jid";
export const AppDomain = "nailsupply.us";
export const FileNamePrefix = "app_file";
export const LatestSyncActiveStatusKey =
  PrefixKey + "web_latest_sync_active_status";
export const MaxSelectFiles = 10;
export const LimitFileSizeMB = 50;
export const LimitFileSize = LimitFileSizeMB * 1024 * 1024;
export const UserCacheKey = "user_cache_info";
export const ShippingInfoCacheKey = "shipping_cache_info";
export const CartInfoCacheKey = "cart_cache_info";
export const OrderIdPrefix = "#Order";
export const GuestCartCacheKey = "guest_cart_info";
export const GuestPostCacheKey = "guest_post_info";
export const ReferralCodeKey = "ref_code";
export const AffiliateCodeKey = "aff_code";
export const PromotionCodeCacheKey = "promotion_code_cache";
export const OrderPreviewCacheKey = "order_preview_cache";
export const CategoryWholesaleCacheKey = "category_wholesale_cache";

export const CacheKey = {
  YEAR_AVAILABLE: PrefixKey + "year_available",
  LOGIN_LOG: PrefixKey + "login_log"
};

// export const SQUARE_CONFIG = {
//   appId: import.meta.env.VITE_SQUARE_APP_ID,
//   locationId: import.meta.env.VITE_SQUARE_LOCATION_ID,
//   defaultCurrency: import.meta.env.VITE_SQUARE_DEFAULT_CURRENCY,
//   scriptUrl: import.meta.env.VITE_SQUARE_UP_LINK
// };

export const ImageDefault = getImageFullPath(
  "/uploads/images/7cc8695d-046e-4db1-bc33-4ed4a9f2a17d.webp"
);

export const CDN_DOMAIN =
  import.meta.env.VITE_CDN_DOMAIN || "https://api.nailsupply.us";
